let AbstractGeometryOperationResult = require('./abstractOperationResult');

/**
 * Класс UnionResult определяет структуру результата при опрерации построения объединения
 * @extends AbstractGeometryOperationResult
 */
class UnionResult extends AbstractGeometryOperationResult {
  /**
   * Создает экземпляр класса UnionResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "UnionResult";
  }
}

module.exports = UnionResult;